<template>
  <div class="com-box" :style="{height: isEdit ? null : pagesHeight}">
    <div class="front" :class="{'active-front': isEdit}" ref="element">
      <div class="head" v-if="!isApplayTemp">
        <div class="head-left">
          <div class="item" v-if="cmpIndex != 0" @click="moveUp">上移</div>
          <div class="item" v-if="comListLength != cmpIndex" @click="shiftDown">下移</div>
          <div class="item" v-if="comListLength > 0" @click="delCmp">删除</div>
        </div>
        <div class="head-right" @click="edit">编辑</div>
      </div>
      <preview-image-video :comData="value" :tmpType="tmpType"/>
    </div>
    <div class="back" :class="{'active-back': isEdit}">
      <image-video v-model="textList"/>
      <div style="height: 60px;"></div>
      <div class="footer">
        <div class="footer-item call" @click="cancel">取消</div>
        <div class="footer-item" @click="save">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import previewImageVideo from '@/pages/activity-home/components/image-video'
import ImageVideo from '../../components/image-video'
import _ from 'loadsh'
import loadingMixin from '@/mixins/loading-mixin'
export default {
  mixins: [loadingMixin],
  components: {
    previewImageVideo,
    ImageVideo,
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Array,
    cmpIndex: Number,
    comListLength: Number,
    isApplayTemp: Boolean,
    tmpType: Number,

  },
  watch: {
    isEdit() {
      this.pagesHeight = window.getComputedStyle(this.$refs.element).height
    }
  },
  data() {
    return {
      isEdit: false,
      formData: [],
      textList: [],
      pagesHeight: '523.547px',
    }
  },
 
  mounted() {
    // 获取组件高度
    setTimeout(()=> {
      let height = window.getComputedStyle(this.$refs.element).height
      this.pagesHeight = height  == '64px' ? '523.547px' : height
    },1500)
  },
  methods: {
    edit() {
      this.textList = _.cloneDeep(this.value)
      this.isEdit = !this.isEdit
      this.$emit('handle',['imageVideo', false])
    },
    cancel() {
      this.isEdit = false
      this.$emit('handle', ['imageVideo', true])
    },
    save() {
      this.showLoading();
      this.$emit('change', this.textList)
      setTimeout(()=> {
        this.pagesHeight = window.getComputedStyle(this.$refs.element).height
        this.isEdit = false
        this.$emit('handle', ['imageVideo', true])
        this.hideLoading();
      },1000)
    },
    delCmp() {
      this.$emit('delCmp',this.cmpIndex)
    },
    moveUp() {
      this.$emit('moveUp',this.cmpIndex)
    },
    shiftDown() {
      this.$emit('shiftDown',this.cmpIndex)
    }
  },
}
</script>

<style lang="stylus" scoped>
.com-box {
  perspective: 800px;
  overflow hidden
  padding: 10px 0;
  box-sizing: border-box
  .front {
    position: absolute;
    left: 0;
    right: 0;
    transition: 1s;
    backface-visibility: hidden;
    .head {
      position: absolute;
      left: 16px;
      width: 91%;
      display: flex;
      justify-content: space-between;
      z-index: 9;
      .head-left {
        display: flex;
        .item {
          padding: 4px;
          border-radius: 3px;
          background: #fff;
          margin-right: 10px;
        }
      }
      .head-right {
        padding: 4px;
        border-radius: 3px;
        background: #fff;
      }
    }
  }
  .back {
    transform: rotateY(-180deg);
    backface-visibility: hidden;
    transition: 1s;
    margin-top: -10px;
    background: #f4f4f4;;
    .footer {
      display: flex;
      justify-content center;
      width: 100%;
      padding: 10px 0;
    }
    .footer-item {
      color: #FFFFFF;
      padding: 10px 26px;
      border-radius: 4px;
      background: #FF6B31;
      margin-left: 20px;
    }
    .call {
      color: #FF6B31;
      background: #fff;
    }
  }
  .active-front {
    transform: rotateY(180deg);
  }
  .active-back {
    transform: rotateY(0deg);
  }
}
  
</style>